(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adspoc-buy-box"] && !Shopify.designMode) return;
  try {
    /* =====================================================================
   Engine for snippets/adspoc-buy-box (Adarsh)
   <adspoc-product> wraps one product: the variant picker (snippets/adspoc-variant-picker),
   the price, quantity and the add-to-cart form. Used by the product page and quick view.

   Data hooks (keep these when restyling):
     data-money-format   on <adspoc-product>, from {{ shop.money_format | json }}
     data-update-url     on <adspoc-product>, "true" on the product page only
     [data-product-json] variants JSON (printed by the picker snippet)
     [data-variant-picker] .adspoc-vp__radio [data-option-select] [data-option-value]
     [data-card-price] [data-card-compare] [data-card-off] [data-card-note]
     [data-price] [data-compare] [data-badge] [data-badge-pct] [data-add-price]
     [data-product-form] (Shopify's product form) [data-variant-id] [data-add-button] [data-add-label]
     [data-qty] [data-qty-input] [data-form-error]
   Events fired on the element (they bubble):
     adspoc:variant-change  detail: { variant }   — galleries listen to this
     adspoc:added           detail: { variant, quantity }
   The header's fetch interceptor sees /cart/add.js and refreshes and opens the cart drawer.
   ===================================================================== */
(() => {
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class AdspocProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const json = this.querySelector('[data-product-json]');
      if (!json || !this.querySelector('[data-variant-id]')) {
        // Defined before the page finished loading: try again once the HTML is all there
        if (document.readyState === 'loading') {
          if (!this._waiting) {
            this._waiting = true;
            document.addEventListener('DOMContentLoaded', () => { this._waiting = false; this.connectedCallback(); }, { once: true });
          }
          return;
        }
        if (!json) return;
      }
      try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = []; return; }
      if (!this.variants.length) return;
      this._ready = true;

      this.moneyFormat = this.dataset.moneyFormat || '₹{{amount}}';
      this.optionCount = this.variants[0].options.length;
      this.radios = [...this.querySelectorAll('.adspoc-vp__radio')];
      this.selects = [...this.querySelectorAll('[data-option-select]')];
      this.idInput = this.querySelector('[data-variant-id]');
      const startId = this.idInput ? String(this.idInput.value) : '';
      const start = this.variants.find((v) => String(v.id) === startId) || this.variants[0];
      this.state = [...start.options];

      this._ac = new AbortController();
      const signal = this._ac.signal;
      this.addEventListener('change', (e) => this.onChange(e), { signal });
      this.addEventListener('click', (e) => this.onClick(e), { signal });
      const form = this.querySelector('[data-product-form], form.adspoc-bb__form');
      if (form) form.addEventListener('submit', (e) => this.onSubmit(e), { signal });

      this.render(start, false);
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      this._ready = false;
    }

    /* ---------- money ---------- */
    money(cents) {
      const val = cents / 100;
      const trim = (n) => n.replace(/\.00$/, '');
      const map = {
        amount: trim(val.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })),
        amount_no_decimals: Math.round(val).toLocaleString('en-IN'),
        amount_with_comma_separator: trim(val.toFixed(2)).replace('.', ','),
        amount_no_decimals_with_comma_separator: Math.round(val).toString(),
        amount_with_apostrophe_separator: trim(val.toFixed(2))
      };
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] ?? map.amount).replace(/<[^>]*>/g, '');
    }

    /* ---------- matching ---------- */
    exact(sel) { return this.variants.find((v) => v.options.every((o, i) => o === sel[i])); }

    /* Closest real variant when the picked combination doesn't exist: keep the value just picked,
       keep as many other picks as possible (earlier options weigh more), prefer in stock. */
    resolve(idx, sel) {
      const hit = this.exact(sel);
      if (hit) return hit;
      let best = null; let bestScore = -1;
      this.variants.forEach((v) => {
        if (v.options[idx] !== sel[idx]) return;
        let score = 0;
        v.options.forEach((o, i) => { if (i !== idx && o === sel[i]) score += (this.optionCount - i) * 2; });
        if (v.available) score += 1;
        if (score > bestScore) { bestScore = score; best = v; }
      });
      return best;
    }

    withValue(idx, val) { const sel = [...this.state]; sel[idx] = val; return this.exact(sel); }
    bestWith(idx, val) { const sel = [...this.state]; sel[idx] = val; return this.resolve(idx, sel); }

    /* ---------- events ---------- */
    onChange(e) {
      const t = e.target;
      if (t.matches('.adspoc-vp__radio') && t.checked) this.pick(parseInt(t.dataset.optionIndex, 10), t.value);
      else if (t.matches('[data-option-select]')) this.pick(parseInt(t.dataset.optionIndex, 10), t.value);
      else if (t.matches('[data-qty-input]')) this.clampQty(t);
    }

    onClick(e) {
      const step = e.target.closest('[data-qty]');
      if (!step) return;
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qty, 10));
      this.clampQty(input);
    }

    clampQty(input) {
      input.value = Math.max(1, parseInt(input.value, 10) || 1);
      const minus = this.querySelector('[data-qty="-1"]');
      if (minus) minus.disabled = Number(input.value) <= 1;
    }

    pick(idx, value) {
      const sel = [...this.state]; sel[idx] = value;
      const v = this.resolve(idx, sel);
      if (v) this.render(v, true);
    }

    /* ---------- render ---------- */
    setCard(label, v) {
      if (!v) return;
      const onSale = v.compare_at_price > v.price;
      const p = label.querySelector('[data-card-price]');
      const c = label.querySelector('[data-card-compare]');
      const o = label.querySelector('[data-card-off]');
      if (p) p.textContent = this.money(v.price);
      if (c) { c.textContent = onSale ? this.money(v.compare_at_price) : ''; c.hidden = !onSale; }
      if (o) { o.textContent = onSale ? Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '% off' : ''; o.hidden = !onSale; }
    }

    render(variant, fromUser) {
      this.state = [...variant.options];

      this.radios.forEach((r) => {
        const idx = parseInt(r.dataset.optionIndex, 10);
        r.checked = r.value === this.state[idx];
        const label = r.nextElementSibling;
        if (!label) return;
        const hit = this.withValue(idx, r.value);
        label.classList.toggle('is-unavailable', !hit);
        label.classList.toggle('is-soldout', !!hit && !hit.available);
        label.title = r.value + (!hit ? ' (not in this selection)' : (!hit.available ? ' (sold out)' : ''));
        if (label.classList.contains('adspoc-vp__card')) {
          this.setCard(label, hit || this.bestWith(idx, r.value));
          const note = label.querySelector('[data-card-note]');
          if (note) note.textContent = !hit ? 'Not in this selection' : (!hit.available ? 'Sold out' : '');
        }
      });

      this.selects.forEach((s) => {
        const idx = parseInt(s.dataset.optionIndex, 10);
        [...s.options].forEach((opt) => {
          const hit = this.withValue(idx, opt.value);
          const shown = hit || this.bestWith(idx, opt.value);
          let text = opt.value + (shown ? ' — ' + this.money(shown.price) : '');
          if (!hit) text += ' · other options';
          else if (!hit.available) text += ' · sold out';
          opt.textContent = text;
        });
        s.value = this.state[idx];
      });

      this.querySelectorAll('[data-option-value]').forEach((el) => {
        const i = parseInt(el.dataset.optionValue, 10);
        if (variant.options[i] != null) el.textContent = variant.options[i];
      });

      if (this.idInput && String(this.idInput.value) !== String(variant.id)) {
        this.idInput.value = variant.id;
        // Checkout apps listen for events, not value changes (Playbook 16.3)
        ['input', 'change'].forEach((t) => this.idInput.dispatchEvent(new Event(t, { bubbles: true })));
        if (this.idInput.form) this.idInput.form.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const onSale = variant.compare_at_price > variant.price;
      const pct = onSale ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
      this.querySelectorAll('[data-price]').forEach((el) => { el.textContent = this.money(variant.price); });
      this.querySelectorAll('[data-compare]').forEach((el) => { el.textContent = onSale ? this.money(variant.compare_at_price) : ''; el.hidden = !onSale; });
      this.querySelectorAll('[data-badge]').forEach((el) => { el.hidden = !onSale; });
      this.querySelectorAll('[data-badge-pct]').forEach((el) => { el.textContent = pct; });
      this.querySelectorAll('[data-add-price]').forEach((el) => { el.textContent = '· ' + this.money(variant.price); });

      const btn = this.querySelector('[data-add-button]');
      if (btn) {
        btn.disabled = !variant.available;
        const label = btn.querySelector('[data-add-label]') || btn;
        label.textContent = variant.available ? (btn.dataset.labelAdd || 'Add to cart') : (btn.dataset.labelSoldout || 'Sold out');
      }

      if (fromUser && this.dataset.updateUrl === 'true') {
        window.history.replaceState(null, '', `?variant=${variant.id}`);
      }
      this.variant = variant;
      this.dispatchEvent(new CustomEvent('adspoc:variant-change', { bubbles: true, detail: { variant, fromUser } }));
    }

    /* ---------- add to cart ---------- */
    async onSubmit(e) {
      const s = e.submitter;
      // Checkout apps (Shiprocket buy now, dynamic checkout) handle their own buttons
      if (s && (s.name === 'checkout' || s.closest('.shopify-payment-button') || s.hasAttribute('data-testid'))) return;
      e.preventDefault();
      const form = e.currentTarget;
      const btn = this.querySelector('[data-add-button]');
      const err = this.querySelector('[data-form-error]');
      if (err) { err.hidden = true; err.textContent = ''; }
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      try {
        const res = await fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
        const qty = Number(new FormData(form).get('quantity')) || 1;
        this.dispatchEvent(new CustomEvent('adspoc:added', { bubbles: true, detail: { variant: this.variant, quantity: qty } }));
      } catch (error) {
        if (err) { err.textContent = error.message; err.hidden = false; }
      } finally {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      }
    }
  }

  define('adspoc-product', AdspocProduct);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adspoc-collection-toolbar"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('adspoc-collection')) return;

    /* <adspoc-collection data-section-id="…"> wraps the toolbar and results of a collection section.
       Filters, sort and chips fetch the new results with the Section Rendering API and swap them in;
       the URL updates so back/forward and sharing work. Anything that fails falls back to a page load. */
    class AdspocCollection extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onPop = this.onPop.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onInput);
        this.addEventListener('click', this.onClick);
        this.addEventListener('submit', (e) => { if (e.target.matches('[data-facets-form]')) { e.preventDefault(); this.apply(); } });
        this.addEventListener('toggle', (e) => this.onToggle(e), true);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        window.addEventListener('popstate', this.onPop);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('popstate', this.onPop);
        this.unlock();
        this._bound = false;
      }

      get form() { return this.querySelector('[data-facets-form]'); }
      isPhone() { return window.matchMedia('(max-width: 749px)').matches; }

      /* ----- open / close ----- */
      onToggle(e) {
        const d = e.target;
        if (!d.matches || !d.matches('.adspoc-facet') || !d.open || this.isPhone()) return;
        this.querySelectorAll('.adspoc-facet[open]').forEach((o) => { if (o !== d) o.open = false; });
      }
      onDocClick(e) {
        if (this.isPhone() || this.contains(e.target) && e.target.closest('.adspoc-facet')) return;
        this.querySelectorAll('.adspoc-facet[open]').forEach((o) => { o.open = false; });
      }
      onKey(e) {
        if (e.key !== 'Escape') return;
        const open = this.querySelector('.adspoc-facet[open]');
        if (open && !this.isPhone()) { open.open = false; open.querySelector('summary').focus(); }
        if (this.form && this.form.classList.contains('is-open')) this.closeSheet();
      }
      openSheet() {
        const f = this.form; if (!f) return;
        f.classList.add('is-open');
        const b = this.querySelector('[data-facets-open]'); if (b) b.setAttribute('aria-expanded', 'true');
        this.lock();
        const x = this.querySelector('.adspoc-facets__x'); if (x) x.focus();
      }
      closeSheet() {
        const f = this.form; if (!f) return;
        f.classList.remove('is-open');
        const b = this.querySelector('[data-facets-open]'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
        this.unlock();
      }
      lock() { document.documentElement.style.overflow = 'hidden'; }
      unlock() { document.documentElement.style.overflow = ''; }

      /* ----- events ----- */
      onClick(e) {
        if (e.target.closest('[data-facets-open]')) { e.preventDefault(); this.openSheet(); return; }
        if (e.target.closest('[data-facets-close]')) { e.preventDefault(); this.closeSheet(); return; }
        const link = e.target.closest('a[data-facets-link]');
        if (link) { e.preventDefault(); this.load(link.href); }
      }
      onChange(e) {
        if (!e.target.closest('[data-facets-form]')) return;
        if (e.target.matches('[data-price-input]')) { clearTimeout(this._t); this.apply(); return; }
        this.apply();
      }
      onInput(e) {
        if (!e.target.matches('[data-price-input]')) return;
        clearTimeout(this._t);
        this._t = setTimeout(() => this.apply(), 900);
      }
      onPop() { this.load(window.location.href, false); }

      /* ----- build URL from the form and load ----- */
      apply() {
        const f = this.form; if (!f) return;
        const params = new URLSearchParams();
        const sortSel = f.querySelector('select[name="sort_by"]');
        const sortDefault = sortSel ? sortSel.dataset.default : '';
        new FormData(f).forEach((v, k) => {
          if (String(v).trim() === '') return;
          if (k === 'sort_by' && v === sortDefault) return;   // keep links clean
          params.append(k, v);
        });
        const url = new URL(f.getAttribute('action') || window.location.pathname, window.location.origin);
        url.search = params.toString();
        this.load(url.toString());
      }

      async load(href, push = true) {
        const id = this.dataset.sectionId;
        const url = new URL(href, window.location.origin);
        // Keep the reels view when a Shopify-made link (chips) drops it
        if (this.dataset.view === 'reels' && !url.searchParams.has('view')) url.searchParams.set('view', 'reels');
        url.searchParams.delete('page');
        const target = url.pathname + url.search;
        if (push && (target === this._pending || (!this._pending && target === window.location.pathname + window.location.search))) return;
        this._pending = target;
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set('section_id', id);

        const state = this.captureState();
        this.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(fetchUrl.toString(), { headers: { Accept: 'text/html' } });
          if (!res.ok) throw new Error(res.status);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(`adspoc-collection[data-section-id="${id}"]`);
          if (!fresh) throw new Error('no section');
          this.innerHTML = fresh.innerHTML;
          if (push) window.history.pushState({}, '', target);
          this.restoreState(state);
        } catch (err) {
          window.location.href = url.toString();
        } finally {
          this._pending = null;
          this.removeAttribute('aria-busy');
        }
      }

      /* Keep open panels, the phone sheet and focus across the swap */
      captureState() {
        const a = document.activeElement;
        const list = this.querySelector('.adspoc-facets__list');
        return {
          open: [...this.querySelectorAll('.adspoc-facet[open]')].map((d) => d.dataset.facet),
          sheet: !!(this.form && this.form.classList.contains('is-open')),
          focus: a && this.contains(a) ? (a.id || (a.name ? 'name:' + a.name : '')) : '',
          scroll: list ? list.scrollTop : 0
        };
      }
      restoreState(s) {
        s.open.forEach((k) => { const d = this.querySelector(`.adspoc-facet[data-facet="${k}"]`); if (d) d.open = true; });
        if (s.sheet && this.form) {
          this.form.classList.add('is-open');
          const b = this.querySelector('[data-facets-open]'); if (b) b.setAttribute('aria-expanded', 'true');
        } else if (!s.sheet) {
          this.unlock();
        }
        const list = this.querySelector('.adspoc-facets__list'); if (list) list.scrollTop = s.scroll;
        if (s.focus) {
          const el = s.focus.startsWith('name:') ? this.querySelector(`[name="${CSS.escape(s.focus.slice(5))}"]`) : this.querySelector('#' + CSS.escape(s.focus));
          if (el) el.focus({ preventScroll: true });
        }
      }
    }
    customElements.define('adspoc-collection', AdspocCollection);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adspoc-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Ensure <adspoc-product> is always registered on any page that renders product cards */
    class AdspocProduct extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        const json = this.querySelector('[data-product-json]');
        if (!json || !this.querySelector('[data-variant-id]')) {
          if (document.readyState === 'loading') {
            if (!this._waiting) {
              this._waiting = true;
              document.addEventListener('DOMContentLoaded', () => { this._waiting = false; this.connectedCallback(); }, { once: true });
            }
            return;
          }
          if (!json) return;
        }
        try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = []; return; }
        if (!this.variants.length) return;
        this._ready = true;

        this.moneyFormat = this.dataset.moneyFormat || '₹{{amount}}';
        this.optionCount = this.variants[0].options.length;
        this.radios = [...this.querySelectorAll('.adspoc-vp__radio')];
        this.selects = [...this.querySelectorAll('[data-option-select]')];
        this.idInput = this.querySelector('[data-variant-id]');
        const startId = this.idInput ? String(this.idInput.value) : '';
        const start = this.variants.find((v) => String(v.id) === startId) || this.variants[0];
        this.state = [...start.options];

        this._ac = new AbortController();
        const signal = this._ac.signal;
        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('click', (e) => this.onClick(e), { signal });
        const form = this.querySelector('[data-product-form], form.adspoc-bb__form');
        if (form) form.addEventListener('submit', (e) => this.onSubmit(e), { signal });

        this.render(start, false);
      }

      disconnectedCallback() {
        if (this._ac) this._ac.abort();
        this._ready = false;
      }

      money(cents) {
        const val = cents / 100;
        const trim = (n) => n.replace(/\.00$/, '');
        const map = {
          amount: trim(val.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })),
          amount_no_decimals: Math.round(val).toLocaleString('en-IN'),
          amount_with_comma_separator: trim(val.toFixed(2)).replace('.', ','),
          amount_no_decimals_with_comma_separator: Math.round(val).toString(),
          amount_with_apostrophe_separator: trim(val.toFixed(2))
        };
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] ?? map.amount).replace(/<[^>]*>/g, '');
      }

      exact(sel) { return this.variants.find((v) => v.options.every((o, i) => o === sel[i])); }

      resolve(idx, sel) {
        const hit = this.exact(sel);
        if (hit) return hit;
        let best = null; let bestScore = -1;
        this.variants.forEach((v) => {
          if (v.options[idx] !== sel[idx]) return;
          let score = 0;
          v.options.forEach((o, i) => { if (i !== idx && o === sel[i]) score += (this.optionCount - i) * 2; });
          if (v.available) score += 1;
          if (score > bestScore) { bestScore = score; best = v; }
        });
        return best;
      }

      withValue(idx, val) { const sel = [...this.state]; sel[idx] = val; return this.exact(sel); }
      bestWith(idx, val) { const sel = [...this.state]; sel[idx] = val; return this.resolve(idx, sel); }

      onChange(e) {
        const t = e.target;
        if (t.matches('.adspoc-vp__radio') && t.checked) this.pick(parseInt(t.dataset.optionIndex, 10), t.value);
        else if (t.matches('[data-option-select]')) this.pick(parseInt(t.dataset.optionIndex, 10), t.value);
        else if (t.matches('[data-qty-input]')) this.clampQty(t);
      }

      onClick(e) {
        const step = e.target.closest('[data-qty]');
        if (!step) return;
        const input = this.querySelector('[data-qty-input]');
        if (!input) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qty, 10));
        this.clampQty(input);
      }

      clampQty(input) {
        input.value = Math.max(1, parseInt(input.value, 10) || 1);
        const minus = this.querySelector('[data-qty="-1"]');
        if (minus) minus.disabled = Number(input.value) <= 1;
      }

      pick(idx, value) {
        const sel = [...this.state]; sel[idx] = value;
        const v = this.resolve(idx, sel);
        if (v) this.render(v, true);
      }

      setCard(label, v) {
        if (!v) return;
        const onSale = v.compare_at_price > v.price;
        const p = label.querySelector('[data-card-price]');
        const c = label.querySelector('[data-card-compare]');
        const o = label.querySelector('[data-card-off]');
        if (p) p.textContent = this.money(v.price);
        if (c) { c.textContent = onSale ? this.money(v.compare_at_price) : ''; c.hidden = !onSale; }
        if (o) { o.textContent = onSale ? Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '% off' : ''; o.hidden = !onSale; }
      }

      render(variant, fromUser) {
        this.state = [...variant.options];

        this.radios.forEach((r) => {
          const idx = parseInt(r.dataset.optionIndex, 10);
          r.checked = r.value === this.state[idx];
          const label = r.nextElementSibling;
          if (!label) return;
          const hit = this.withValue(idx, r.value);
          label.classList.toggle('is-unavailable', !hit);
          label.classList.toggle('is-soldout', !!hit && !hit.available);
          label.title = r.value + (!hit ? ' (not in this selection)' : (!hit.available ? ' (sold out)' : ''));
          if (label.classList.contains('adspoc-vp__card')) {
            this.setCard(label, hit || this.bestWith(idx, r.value));
            const note = label.querySelector('[data-card-note]');
            if (note) note.textContent = !hit ? 'Not in this selection' : (!hit.available ? 'Sold out' : '');
          }
        });

        this.selects.forEach((s) => {
          const idx = parseInt(s.dataset.optionIndex, 10);
          [...s.options].forEach((opt) => {
            const hit = this.withValue(idx, opt.value);
            const shown = hit || this.bestWith(idx, opt.value);
            let text = opt.value + (shown ? ' — ' + this.money(shown.price) : '');
            if (!hit) text += ' · other options';
            else if (!hit.available) text += ' · sold out';
            opt.textContent = text;
          });
          s.value = this.state[idx];
        });

        this.querySelectorAll('[data-option-value]').forEach((el) => {
          const i = parseInt(el.dataset.optionValue, 10);
          if (variant.options[i] != null) el.textContent = variant.options[i];
        });

        if (this.idInput && String(this.idInput.value) !== String(variant.id)) {
          this.idInput.value = variant.id;
          ['input', 'change'].forEach((t) => this.idInput.dispatchEvent(new Event(t, { bubbles: true })));
          if (this.idInput.form) this.idInput.form.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const onSale = variant.compare_at_price > variant.price;
        const pct = onSale ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
        this.querySelectorAll('[data-price]').forEach((el) => { el.textContent = this.money(variant.price); });
        this.querySelectorAll('[data-compare]').forEach((el) => { el.textContent = onSale ? this.money(variant.compare_at_price) : ''; el.hidden = !onSale; });
        this.querySelectorAll('[data-badge]').forEach((el) => { el.hidden = !onSale; });
        this.querySelectorAll('[data-badge-pct]').forEach((el) => { el.textContent = pct; });
        this.querySelectorAll('[data-add-price]').forEach((el) => { el.textContent = '· ' + this.money(variant.price); });

        const btn = this.querySelector('[data-add-button]');
        if (btn) {
          btn.disabled = !variant.available;
          const label = btn.querySelector('[data-add-label]') || btn;
          label.textContent = variant.available ? (btn.dataset.labelAdd || 'Add to cart') : (btn.dataset.labelSoldout || 'Sold out');
        }

        if (fromUser && this.dataset.updateUrl === 'true') {
          window.history.replaceState(null, '', `?variant=${variant.id}`);
        }
        this.variant = variant;
        this.dispatchEvent(new CustomEvent('adspoc:variant-change', { bubbles: true, detail: { variant, fromUser } }));
      }

      async onSubmit(e) {
        const s = e.submitter;
        if (s && (s.name === 'checkout' || s.closest('.shopify-payment-button') || s.hasAttribute('data-testid'))) return;
        e.preventDefault();
        const form = e.currentTarget;
        const btn = this.querySelector('[data-add-button]');
        const err = this.querySelector('[data-form-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        try {
          const res = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
          const qty = Number(new FormData(form).get('quantity')) || 1;
          this.dispatchEvent(new CustomEvent('adspoc:added', { bubbles: true, detail: { variant: this.variant, quantity: qty } }));
        } catch (error) {
          if (err) { err.textContent = error.message; err.hidden = false; }
        } finally {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        }
      }
    }
    define('adspoc-product', AdspocProduct);

    /* Quick add on the product card (and the Watch & Shop tiles and viewer). */
    class AdspocQuickAdd extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link || this._bound) return;
        this._bound = true;
        this.onClick = this.onClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        if (this.link) this.link.removeEventListener('click', this.onClick);
        this._bound = false;
      }
      async onClick(e) {
        const id = this.dataset.variantId;
        e.preventDefault();
        if (!id) {
          window.AdspocQuickView.open(this.dataset.url, this.link);
          return;
        }
        if (this.hasAttribute('aria-busy')) return;
        this.setAttribute('aria-busy', 'true');
        const label = this.querySelector('[data-quick-label]');
        try {
          const res = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');
          this.classList.add('is-added');
          if (label) label.textContent = this.dataset.labelAdded || 'Added';
          setTimeout(() => {
            this.classList.remove('is-added');
            if (label) label.textContent = this.dataset.label || '';
          }, 1800);
        } catch (err) {
          window.location.href = this.dataset.url;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }
    define('adspoc-quick-add', AdspocQuickAdd);

    if (window.AdspocQuickView) return;
    const QV = {
      build() {
        if (this.el) return;
        const el = document.createElement('div');
        el.className = 'adspoc-qv-modal';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.setAttribute('aria-label', 'Quick view');
        el.innerHTML =
          '<div class="adspoc-qv-modal__backdrop" data-qv-close></div>' +
          '<div class="adspoc-qv-modal__panel">' +
            '<span class="adspoc-qv-modal__grab" aria-hidden="true"></span>' +
            '<button type="button" class="adspoc-qv-modal__x" data-qv-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
            '<div class="adspoc-qv-modal__body" data-qv-body></div>' +
          '</div>';
        document.body.appendChild(el);
        this.el = el;
        this.body = el.querySelector('[data-qv-body]');
        this.panel = el.querySelector('.adspoc-qv-modal__panel');

        el.addEventListener('click', (e) => {
          if (e.target.closest('[data-qv-close]')) { this.close(); return; }
          if (e.target.closest('[data-qv-prev]')) { this.step(-1); return; }
          if (e.target.closest('[data-qv-next]')) { this.step(1); return; }
          const t = e.target.closest('[data-qv-thumb]');
          if (t) this.goTo(Number(t.dataset.qvThumb));
        });
        el.addEventListener('adspoc:variant-change', (e) => this.onVariant(e.detail && e.detail.variant));
        el.addEventListener('adspoc:added', () => {
          this.close(true);
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const drawer = document.querySelector('cart-drawer, cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        });
        document.addEventListener('keydown', (e) => {
          if (!this.isOpen) return;
          if (e.key === 'Escape') { e.preventDefault(); this.close(); }
          else if (e.key === 'Tab') this.trap(e);
        });
        let y0 = null;
        this.panel.addEventListener('touchstart', (e) => { y0 = (this.body.scrollTop <= 0) ? e.touches[0].clientY : null; }, { passive: true });
        this.panel.addEventListener('touchend', (e) => {
          if (y0 === null) return;
          if (e.changedTouches[0].clientY - y0 > 90) this.close();
          y0 = null;
        });
      },

      async open(url, opener) {
        if (!url) return;
        this.build();
        this.opener = opener || document.activeElement;
        this.isOpen = true;
        this.body.innerHTML = '<div class="adspoc-qv-modal__loading"><span class="adspoc-qv-modal__spinner" aria-label="Loading"></span></div>';
        this.el.classList.add('is-open');
        this.prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.dispatchEvent(new CustomEvent('adspoc:quickview-open'));
        const x = this.el.querySelector('.adspoc-qv-modal__x'); if (x) x.focus({ preventScroll: true });

        const u = new URL(url, window.location.origin);
        u.search = '';
        u.searchParams.set('section_id', 'adspoc-quick-view');
        const token = (this._token = Symbol('qv'));
        try {
          const res = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const qv = doc.querySelector('[data-qv]');
          if (!qv || !customElements.get('adspoc-product')) throw new Error('quick view unavailable');
          if (token !== this._token || !this.isOpen) return;
          this.body.replaceChildren(qv);
          this.setup(qv);
          const h = qv.querySelector('h2'); if (h) { h.setAttribute('tabindex', '-1'); this.el.setAttribute('aria-labelledby', h.id); }
        } catch (err) {
          window.location.href = url;
        }
      },

      close(silent) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this._token = null;
        this.el.classList.remove('is-open');
        this.body.replaceChildren();
        document.documentElement.style.overflow = this.prevOverflow || '';
        if (!silent && this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
      },

      setup(qv) {
        this.qv = qv;
        this.track = qv.querySelector('[data-qv-track]');
        this.thumbs = qv.querySelector('[data-qv-thumbs]');
        try { this.galleries = JSON.parse(qv.querySelector('[data-qv-galleries]').textContent || '{}'); } catch (e) { this.galleries = {}; }
        const norm = (x) => String(x ?? '').toLowerCase().replace(/\s+/g, '');
        this.gList = Object.keys(this.galleries).filter((k) => k !== '__default' && (this.galleries[k] || []).length)
          .map((k) => ({ key: k, parts: k.split('/').map(norm).filter(Boolean) }));
        this.pick = (opts) => {
          const vals = (opts || []).map(norm);
          let best = null, score = 0;
          this.gList.forEach((g) => { if (g.parts.every((p) => vals.includes(p)) && g.parts.length > score) { best = g.key; score = g.parts.length; } });
          return best;
        };
        this.gallery = this.gList.length ? (this.pick((qv.dataset.currentOptions || '').split('||')) || '__default') : null;
        this.renderThumbs();
        this.track.addEventListener('scroll', () => this.syncThumbs(), { passive: true });
      },
      slides() { return [...this.track.children]; },
      renderThumbs() {
        const slides = this.slides();
        const many = slides.length > 1;
        this.qv.querySelectorAll('[data-qv-prev], [data-qv-next]').forEach((b) => { b.hidden = !many; });
        this.thumbs.replaceChildren();
        if (!many) return;
        slides.slice(0, 5).forEach((s, i) => {
          const img = s.querySelector('img');
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'adspoc-qv__thumb' + (i === 0 ? ' is-active' : '');
          b.dataset.qvThumb = i;
          b.setAttribute('aria-label', 'Show image ' + (i + 1));
          if (img) { const t = img.cloneNode(); t.removeAttribute('srcset'); t.removeAttribute('sizes'); t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
          this.thumbs.appendChild(b);
        });
      },
      current() { return this.track ? Math.round(this.track.scrollLeft / (this.slides()[0]?.offsetWidth || 1)) : 0; },
      goTo(i) {
        const s = this.slides()[i]; if (!s) return;
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft - (parseFloat(getComputedStyle(this.track).paddingLeft) || 0), behavior: 'smooth' });
      },
      step(d) {
        const n = this.slides().length; if (!n) return;
        this.goTo((this.current() + d + n) % n);
      },
      syncThumbs() {
        const i = this.current();
        this.thumbs.querySelectorAll('.adspoc-qv__thumb').forEach((t, k) => t.classList.toggle('is-active', k === i));
      },
      onVariant(v) {
        if (!v || !this.track) return;
        if (this.gList && this.gList.length) {
          const next = this.pick(v.options) || '__default';
          const imgs = this.galleries[next];
          if (next !== this.gallery && imgs && imgs.length) {
            this.gallery = next;
            this.track.replaceChildren(...imgs.map((m) => {
              const d = document.createElement('div');
              d.className = 'adspoc-qv__slide';
              if (m.id) d.dataset.mediaId = m.id;
              const im = document.createElement('img');
              im.src = m.src; im.alt = m.alt || ''; im.loading = 'eager';
              d.appendChild(im);
              return d;
            }));
            this.track.scrollTo({ left: 0 });
            this.renderThumbs();
            return;
          }
        }
        const id = v.featured_media && v.featured_media.id;
        if (id) {
          const idx = this.slides().findIndex((s) => s.dataset.mediaId === String(id));
          if (idx > -1) this.goTo(idx);
        }
      },

      trap(e) {
        const f = [...this.el.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select, [tabindex="0"]')]
          .filter((n) => n.offsetParent !== null);
        if (!f.length) return;
        const first = f[0]; const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    window.AdspocQuickView = QV;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adspoc-reels-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('adspoc-reels')) return;
    const mq = (q) => window.matchMedia(q).matches;

    /* <adspoc-reels> runs the Watch & Shop grid and the homepage reels row: silent previews, load more, row arrows and the viewer.
       data-previews="true" turns on silent previews (off for people who prefer reduced motion). */
    class AdspocReels extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.grid = this.querySelector('[data-reels-grid]');
        this.tiles = [...this.querySelectorAll('[data-reel]')];
        this.previews = this.dataset.previews === 'true' && !mq('(prefers-reduced-motion: reduce)');
        this.hover = mq('(hover: hover) and (pointer: fine)');
        this.muted = false;
        this.ratios = new Map();

        if (this.previews && !this.hover && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => this.onIntersect(entries), { threshold: [0, 0.3, 0.6, 0.9] });
        }
        this.tiles.forEach((t) => this.bindTile(t));

        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.onVis = () => { if (document.hidden) this.stopPreview(); };
        document.addEventListener('visibilitychange', this.onVis);
        // Quick view opening on top (Choose options): pause the viewer video and previews
        this.onQv = () => { this.stopPreview(); if (this.isOpen && this.vVideo) this.vVideo.pause(); };
        document.addEventListener('adspoc:quickview-open', this.onQv);

        // Homepage row arrows (adspoc-reels-showcase): off at the ends, hidden when everything fits
        this.arrows = this.querySelector('[data-reels-arrows]');
        if (this.arrows) {
          this.grid.addEventListener('scroll', () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this.syncRow()); }, { passive: true });
          this.onResize = () => this.syncRow();
          window.addEventListener('resize', this.onResize);
          requestAnimationFrame(() => this.syncRow());
        }

        if (!this.tiles.length && this.querySelector('[data-reels-more]')) this.loadMore(true);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        document.removeEventListener('visibilitychange', this.onVis);
        document.removeEventListener('adspoc:quickview-open', this.onQv);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.viewer) { this.close(); this.viewer.remove(); this.viewer = null; }
        this._ready = false;
      }

      bindTile(tile) {
        if (tile._bound) return;
        tile._bound = true;
        if (this.previews && this.hover) {
          tile.addEventListener('mouseenter', () => this.preview(tile));
          tile.addEventListener('mouseleave', () => { if (this.current === tile) this.stopPreview(); });
        }
        if (this.io) this.io.observe(tile);
        const v = tile.querySelector('video');
        const bar = tile.querySelector('[data-reel-prog]');
        if (v && bar) v.addEventListener('timeupdate', () => { if (v.duration) bar.style.width = (v.currentTime / v.duration) * 100 + '%'; });
      }

      onClick(e) {
        const open = e.target.closest('[data-reel-open]');
        if (open) { e.preventDefault(); this.open(this.tiles.indexOf(open.closest('[data-reel]'))); return; }
        const more = e.target.closest('[data-reels-more]');
        if (more) { e.preventDefault(); this.loadMore(true); return; }
        const step = e.target.closest('[data-reels-step]');
        if (step) this.stepRow(Number(step.dataset.reelsStep));
      }
      stepRow(dir) {
        const g = this.grid; if (!g || !g.firstElementChild) return;
        const gap = parseFloat(getComputedStyle(g).columnGap) || 16;
        const w = g.firstElementChild.getBoundingClientRect().width + gap;
        const max = g.scrollWidth - g.clientWidth;
        g.scrollTo({ left: Math.max(0, Math.min(max, g.scrollLeft + dir * w)), behavior: 'smooth' });
      }
      syncRow() {
        if (!this.arrows || !this.grid) return;
        const g = this.grid; const max = g.scrollWidth - g.clientWidth;
        const [prev, next] = this.arrows.querySelectorAll('button');
        this.arrows.hidden = max <= 4;
        prev.disabled = g.scrollLeft <= 4;
        next.disabled = g.scrollLeft >= max - 4;
      }

      /* ----- silent previews ----- */
      onIntersect(entries) {
        entries.forEach((en) => this.ratios.set(en.target, en.isIntersecting ? en.intersectionRatio : 0));
        let best = null; let bestR = 0.6;
        this.ratios.forEach((r, t) => { if (r >= bestR) { best = t; bestR = r; } });
        if (best && best !== this.current) this.preview(best);
        else if (!best) this.stopPreview();
      }
      preview(tile) {
        if (this.isOpen) return;
        if (this.current && this.current !== tile) this.stopPreview();
        const v = tile.querySelector('video');
        if (!v || !tile.dataset.tileSrc) return;
        this.current = tile;
        if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = tile.dataset.tileSrc; }
        v.muted = true;
        const p = v.play();
        if (p && p.then) p.then(() => { if (this.current === tile) tile.classList.add('is-playing'); }).catch(() => {});
        else tile.classList.add('is-playing');
      }
      stopPreview() {
        const t = this.current; if (!t) return;
        const v = t.querySelector('video'); if (v) v.pause();
        t.classList.remove('is-playing');
        this.current = null;
      }

      /* ----- load more: next page of the collection, reels only ----- */
      async loadMore(keepGoing) {
        if (this._loading) return 0;
        let added = 0; let guard = 0;
        this._loading = true;
        try {
          do {
            const link = this.querySelector('[data-reels-more]');
            if (!link) break;
            link.classList.add('is-loading');
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const res = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
            if (!res.ok) { window.location.href = link.href; return 0; }
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const fresh = doc.querySelector('adspoc-reels');
            if (!fresh) break;
            fresh.querySelectorAll('[data-reel]').forEach((t) => {
              this.grid.appendChild(t);
              this.tiles.push(t);
              this.bindTile(t);
              added += 1;
            });
            const wrap = this.querySelector('[data-reels-more-wrap]');
            const nextWrap = fresh.querySelector('[data-reels-more-wrap]');
            if (wrap) { if (nextWrap) wrap.replaceWith(nextWrap); else wrap.remove(); }
            guard += 1;
            if (!nextWrap && this.tiles.length === 0) {
              const empty = fresh.querySelector('[data-reels-empty]');
              const searching = this.querySelector('[data-reels-searching]');
              if (searching) searching.replaceWith(empty || document.createTextNode(''));
            }
          } while (keepGoing && added === 0 && guard < 8);
          if (this.tiles.length) { const s = this.querySelector('[data-reels-searching]'); if (s) s.remove(); }
        } catch (err) {
          const link = this.querySelector('[data-reels-more]');
          if (link) window.location.href = link.href;
        } finally {
          this._loading = false;
          const link = this.querySelector('[data-reels-more]');
          if (link) link.classList.remove('is-loading');
          if (this.viewer) this.syncNav();
        }
        return added;
      }

      /* ----- viewer ----- */
      build() {
        const tpl = this.querySelector('template[data-reels-viewer]');
        if (!tpl) return false;
        this.viewer = tpl.content.firstElementChild.cloneNode(true);
        document.body.appendChild(this.viewer);
        const $ = (s) => this.viewer.querySelector(s);
        this.vVideo = $('[data-rv-video]');
        this.vPanel = $('[data-rv-panel]');
        this.vCount = $('[data-rv-count]');
        this.vProg = $('[data-rv-prog]');
        this.vPrev = $('[data-rv-prev]');
        this.vNext = $('[data-rv-next]');
        this.vMute = $('[data-rv-mute]');

        this.viewer.addEventListener('click', (e) => {
          if (e.target.closest('[data-rv-close]')) { this.close(); return; }
          if (e.target.closest('[data-rv-prev]')) { this.go(-1); return; }
          if (e.target.closest('[data-rv-next]')) { this.go(1); return; }
          if (e.target.closest('[data-rv-mute]')) { this.setMuted(!this.muted); return; }
          if (e.target.closest('[data-rv-tap]') && !this._swiped) this.togglePlay();
        });
        this.vVideo.addEventListener('timeupdate', () => { const v = this.vVideo; if (v.duration) this.vProg.style.width = (v.currentTime / v.duration) * 100 + '%'; });
        this.vVideo.addEventListener('play', () => this.viewer.classList.remove('is-paused'));
        this.vVideo.addEventListener('pause', () => this.viewer.classList.add('is-paused'));

        this.onKey = (e) => {
          if (!this.isOpen || (window.AdspocQuickView && window.AdspocQuickView.isOpen)) return;
          if (e.key === 'Escape') { e.preventDefault(); this.close(); }
          else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
          else if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this.onKey);

        let wheelAt = 0;
        this.viewer.addEventListener('wheel', (e) => {
          if (e.target.closest('[data-rv-panel]')) return;
          e.preventDefault();
          const now = Date.now();
          if (Math.abs(e.deltaY) < 20 || now - wheelAt < 650) return;
          wheelAt = now;
          this.go(e.deltaY > 0 ? 1 : -1);
        }, { passive: false });

        let sy = 0; let sx = 0;
        const player = $('[data-rv-player]');
        player.addEventListener('touchstart', (e) => { sy = e.touches[0].clientY; sx = e.touches[0].clientX; this._swiped = false; }, { passive: true });
        player.addEventListener('touchmove', (e) => { e.preventDefault(); }, { passive: false });
        player.addEventListener('touchend', (e) => {
          const dy = e.changedTouches[0].clientY - sy; const dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) { this._swiped = true; this.go(dy < 0 ? 1 : -1); setTimeout(() => { this._swiped = false; }, 350); }
        });
        return true;
      }

      open(i) {
        if (i < 0) return;
        if (!this.viewer && !this.build()) return;
        this.stopPreview();
        this.lastFocus = document.activeElement;
        this.isOpen = true;
        this.idx = i;
        this.viewer.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        this.render();
        const c = this.viewer.querySelector('.adspoc-rv__close'); if (c) c.focus({ preventScroll: true });
      }
      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        const v = this.vVideo;
        if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
        this.viewer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        const tile = this.tiles[this.idx];
        const back = tile && tile.querySelector('[data-reel-open]');
        if (back) back.focus({ preventScroll: true }); else if (this.lastFocus) this.lastFocus.focus({ preventScroll: true });
        if (tile && !mq('(max-width: 749px)')) tile.scrollIntoView({ block: 'nearest' });
      }
      async go(step) {
        const n = this.idx + step;
        if (n < 0) return;
        if (n >= this.tiles.length) {
          if (!this.querySelector('[data-reels-more]')) return;
          await this.loadMore(true);
          if (n >= this.tiles.length) return;
        }
        this.idx = n;
        this.render();
      }
      render() {
        const tile = this.tiles[this.idx]; if (!tile) return;
        const v = this.vVideo;
        v.poster = tile.dataset.poster || '';
        v.src = tile.dataset.fullSrc || tile.dataset.tileSrc;
        v.muted = this.muted;
        this.vProg.style.width = '0';
        const p = v.play();
        if (p && p.catch) p.catch(() => { if (!v.muted) { this.setMuted(true); v.play().catch(() => {}); } });
        const tpl = tile.querySelector('template[data-reel-product]');
        this.vPanel.replaceChildren(tpl ? tpl.content.cloneNode(true) : '');
        this.syncNav();
        this.setMuted(this.muted);
      }
      syncNav() {
        if (!this.viewer) return;
        const more = !!this.querySelector('[data-reels-more]');
        this.vCount.textContent = (this.idx + 1) + ' / ' + this.tiles.length + (more ? '+' : '');
        this.vPrev.disabled = this.idx <= 0;
        this.vNext.disabled = this.idx >= this.tiles.length - 1 && !more;
      }
      setMuted(m) {
        this.muted = m;
        if (this.vVideo) this.vVideo.muted = m;
        this.viewer.classList.toggle('is-muted', m);
        this.vMute.setAttribute('aria-pressed', String(m));
        this.vMute.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
      }
      togglePlay() {
        const v = this.vVideo;
        if (v.paused) v.play().catch(() => {}); else v.pause();
      }
      trapFocus(e) {
        const f = [...this.viewer.querySelectorAll('button:not([disabled]), a[href]')].filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0]; const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    customElements.define('adspoc-reels', AdspocReels);
  })();
  } catch(e) { console.error(e); }
})();

})();
